var map = {
	"./bB.svg": 50,
	"./bK.svg": 75,
	"./bN.svg": 51,
	"./bP.svg": 76,
	"./bQ.svg": 52,
	"./bR.svg": 53,
	"./wB.svg": 33,
	"./wK.svg": 77,
	"./wN.svg": 34,
	"./wP.svg": 78,
	"./wQ.svg": 35,
	"./wR.svg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;